import React, { useEffect, useState, useMemo } from "react";
import { decodeHtml } from "../../../../../assests/extention/commonfunction";
import { useSelector, shallowEqual } from "react-redux";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import AddCategorySubcategory from "../IndiviualFlow/AddCategorySubcategory";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import SkillSelector from "../../../../Common/SkillSelector";

export default function EAddSkills({ formData, setFormData, nextPage, previousPage }) {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const skillList = useSelector(
    ({ categary: { skilllistwithcategory } }) => skilllistwithcategory,
    shallowEqual
  );

  // Use skillList directly as an array (initial Redux state is {}, so guard it)
  const allSkills = useMemo(() => Array.isArray(skillList) ? skillList : [], [skillList]);

  // Computed validation values
  const categoriesValid = useMemo(() =>
    Array.isArray(formData?.categories) && formData.categories.length > 0
    , [formData?.categories]);

  const skillsValid = useMemo(() =>
    Array.isArray(formData?.skills) && formData.skills.length >= 3
    , [formData?.skills]);

  // Reset submitted when the page mounts
  useEffect(() => {
    setSubmitted(false);
  }, []);

  const submitAndNext = async () => {
    setSubmitted(true);

    if (skillsValid && categoriesValid) {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      nextPage();
      setLoading(false);
    }
  };

  const goBack = () => {
    setSubmitted(false);
    previousPage();
  };

  return (
    <div>
      <div className="row about-row">
        <div className="col-lg-4 about-left">
          <h6>
            <span className="about-step">02/06</span> <span>Required competencies</span>
          </h6>
          <h2>What are your expertise and competencies?</h2>
          <p>Choose or search competencies required</p>
        </div>

        <div className="col-lg-6 about-right">
          <h6>Search or add competencies</h6>

          <AddCategorySubcategory
            formData={formData}
            setFormData={setFormData}
            validationForCategory={submitted && !categoriesValid}
          />

          <SkillSelector
            allSkills={allSkills}
            selectedSkills={formData.skills || []}
            setSelectedSkills={(updatedSkills) => {
              setFormData((prev) => ({ ...prev, skills: updatedSkills }));
            }}
            formData={formData}
            setFormData={setFormData}
            validation={submitted && !skillsValid}
          />

          <div className="popular-skill">
            <h5>Popular competencies based on your designation</h5>
            <div className="add-skills">
              {allSkills
                .filter((skill) => !(formData.skills || []).some((s) => s.id == skill.id))
                .slice(0, 15)
                .map((skill) => (
                  <div key={skill.id}>
                    <p
                      className="select-deactive-skill"
                      onClick={() => {
                        const newSkill = { id: skill.id, title: skill.title };
                        const updatedSkills = [...(formData.skills || []), newSkill];
                        setFormData((prev) => ({
                          ...prev,
                          skills: updatedSkills,
                        }));
                      }}
                    >
                      {decodeHtml(skill.title)} <span>+</span>
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className="button-container">
        <button
          disabled={loading}
          type="button"
          onClick={goBack}
          className="prev-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt=""
          />
          Back
        </button>

        <button type="button" onClick={submitAndNext} className="next-button">
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
}
